import { api } from '@shared/api/api';

export const endTimeTrackingEntryById = api.createTrigger('/time-tracking-entries/:id/end');
